import 'fslightbox';
import page from '../helpers/page';

const fsLightbox = new FsLightbox();
fsLightbox.props.type = "image";
fsLightbox.props.types = [null, null, "video"];
page(() => {});
